module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "chat",
    attrs: {
      "color": "secondary",
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Notifications")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.sortedNotifications), function(notification) {
    return [_c('v-list-tile', {
      key: notification.id,
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s((notification.read) ? notification.message : notification.message.bold())
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s((notification.read) ? new Date(notification.timestamp).toLocaleString() + ' - Seen' : new Date(notification.timestamp).toLocaleString())
      }
    }), _vm._v(" "), _c('v-card-actions', [(notification.type == 'ContactRequest') ? _c('v-btn', {
      attrs: {
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          _vm.respond(notification, true)
        }
      }
    }, [_vm._v("Accept")]) : _vm._e(), _vm._v(" "), (notification.type == 'ContactRequest') ? _c('v-btn', {
      attrs: {
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          _vm.respond(notification, false)
        }
      }
    }, [_vm._v("Reject")]) : _vm._e()], 1)], 1)], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17be2586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Messages.vue
// module id = 58
// module chunks = 1 6